import React, { useState, useEffect } from 'react'
import "./CSS/EditProfile.css"
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { ValueService } from 'ag-grid-community';
import Store from '../Store/Store';
import { set_profile_infos } from '../Action/Action';
import { connect } from 'react-redux';

const Editprofile_ = (props) => {

    const history = useHistory()



    const [selectedImage, setSelectedImage] = useState("");

    const handleImageUpload = (e) => {
        const file = e.target.files[0];
        const reader = new FileReader();
        console.log(e.target.value);

        reader.onload = async (event) => {
            console.log(event);
            let long_string = event.target.result;
            setSelectedImage(long_string);
        };

        try {
            reader.readAsDataURL(file); // Bu satırın reader.onload'un dışında olması gerekiyor
        } catch (err) {
            console.log(err);
        }
    };


    const [inputValue3, setInputValue3] = useState('');
    const [selectedOption3, setSelectedOption3] = useState('Select Role');
    const [selectedOption3_3, setSelectedOption3_3] = useState([]);

    const [isActive3, setIsActive3] = useState(false)
    const [factory, SetFactory] = useState("")
    const [company, Setcompany] = useState("")
    const [department, Setdepartment] = useState("")
    const [competence, Setcompetence] = useState("")
    const [roles, Setroles] = useState("")
    const [username, Setusername] = useState("")
    const [name, Setname] = useState("")
    const [surname, Setsurname] = useState("")
    const [email, Setemail] = useState("")
    const [phone, Setphone] = useState("")
    const [phone2, Setphone2] = useState("")
    const [email2, Setemail2] = useState("")
    const [address, Setaddress] = useState("")


    const onSubmit_func = async e => {
        e.preventDefault()

        let obj = {
            name: name,
            surname: surname,
            department: department,
            competence: company,
            company: company,
            phone: phone,
            phone2: phone2,
            address: address,
            email2: email2,
            roles: selectedOption3_3,
            factory: factory,
            company_img: selectedImage
        }
        if (checkEmail(document.querySelector("#email2")) === 1) {
            await Store.dispatch(set_profile_infos(obj))
            localStorage.setItem("profile_info", JSON.stringify(obj))
            history.push("/profile")
        }

    }

    const Error1 = (inp, msg) => {
        inp.className = "form-control is-invalid"
        const div = inp.nextElementSibling
        div.innerText = msg
        div.className = "inform_login_text invalid-feedback"
    }

    const Success = (inp) => {
        inp.className = "form-control is-valid"
        const div = inp.nextElementSibling
        div.innerText = ""
        div.className = ""
    }


    const checkEmail = (inp) => {
        const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (inp.value === "") {
            Error1(inp, "Email is required!")
            return 0
        } else {
            if (re.test(inp.value)) {
                Success(inp)
                return 1
            } else {
                Error1(inp, "Invalid email address")
                return 0
            }
        }

    }


    const onchangefactory = e => {
        SetFactory(e.target.value)
    }
    const onchangecompany = e => {
        Setcompany(e.target.value)
    }
    const onchangedepartment = e => {
        Setdepartment(e.target.value)
    }
    const onchangecompetence = e => {
        Setcompetence(e.target.value)
    }
    const onchangeroles = e => {
        Setroles(e.target.value)
    }
    const onchangeusername = e => {
        Setusername(e.target.value)
    }
    const onchangename = e => {
        Setname(e.target.value)
    }
    const onchangesurname = e => {
        Setsurname(e.target.value)
    }
    const onchangeemail = e => {
        Setemail(e.target.value)
    }
    const onchangephone2 = e => {
        Setphone2(e.target.value)
    }
    const onchangephone = e => {
        Setphone(e.target.value)
    }
    const onchangeemail2 = e => {
        Setemail2(e.target.value)
    }
    const onchangeaddress = e => {
        Setaddress(e.target.value)
    }
        ;

    const handleDropdownClick3 = () => {
        setIsActive3(!isActive3);
    };

    const handleDropdownBlur3 = () => {
        setIsActive3(false);
    };
    const handleOptionClick3 = (optionValue) => {
        setSelectedOption3(optionValue);
        setInputValue3(optionValue);
        var newdata = selectedOption3_3
        newdata.push(optionValue)
        setSelectedOption3_3(newdata)
    };

    return (
        <section className='edit_profile_section'>
            <div className="bottom_of_infos_xswer">
                <div className="user_info">
                    <div style={{ width: "100%", textAlign: "center" }} className="row2">User Informations</div>
                    <div className="row">Username: <input disabled={true} value={props.username} onChange={onchangeusername} type="text" /> </div>
                    <div className="row">Name: <input value={name} onChange={onchangename} type="text" /> </div>
                    <div className="row">Surname: <input value={surname} onChange={onchangesurname} type="text" /> </div>
                    <div className="row">Email: <input disabled={true} value={props.email} type="email" /> </div>
                    <div className="row">Phone: <input value={phone} onChange={onchangephone} type="tel" />  </div>
                    <div className="row">Deparmant: <input value={department} onChange={onchangedepartment} type="text" /></div>
                    <div className="row">Competence: <input value={competence} onChange={onchangecompetence} type="text" /></div>
                    <div className="row">
                        Roles:
                        <div className={`dropdown ${isActive3 ? 'active' : ''}`} tabIndex="1" onClick={handleDropdownClick3} onBlur={handleDropdownBlur3}>
                            <div className="select">
                                { selectedOption3==="Select Role"?selectedOption3:selectedOption3_3.map((item,index)=>{
                                    var virgül=false;
                                    if(index!==0){
                                        virgül = true
                                    }
                                    return <span>{virgül ?",":"" } {item}</span>
                                })}
                                
                                <i className="fa fa-chevron-left"></i>
                            </div>
                            <input type="hidden" value={inputValue3} />
                            <ul className="dropdown-menu">
                                <li onClick={(e) => { handleOptionClick3(e.target.textContent) }} key='1'>Admin</li>
                                <li onClick={(e) => { handleOptionClick3(e.target.textContent) }} key='2'>RMMS User</li>
                                <li onClick={(e) => { handleOptionClick3(e.target.textContent) }} key='3'>Business User</li>
                                <li onClick={(e) => { handleOptionClick3(e.target.textContent) }} key='4'>Business Admin</li>

                            </ul>
                        </div>
                    </div>
                </div>
                <div className="company_info">
                    <div style={{ width: "100%", textAlign: "center" }} className="row2">Company Informations</div>

                    <div className="row">Company: <input value={company} onChange={onchangecompany} type="text" /></div>
                    <div className="row">Factory: <input type="text" value={factory} onChange={onchangefactory} /> </div>
                    <div className="row">Address: <input type="text" value={address} onChange={onchangeaddress} /> </div>
                    <div className="row">Email: <input type="email" id='email2' value={email2} onChange={onchangeemail2} /><div style={{ position: "absolute", fontSize: "15px", left: "76.5%", bottom: "12%" }}></div> </div>
                    <div className="row">Phone: <input type="tel" value={phone2} onChange={onchangephone2} />  </div>
                    <div className="row">{selectedImage === "" ? <div style={{ color: "black", display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }}>Company Logo: <input onChange={handleImageUpload} style={{ width: "50%" }} type="file" /></div> : <img src={selectedImage} className='edit_company_logo' />}</div>
                </div>
            </div>
            <div className="save_btn_31">
                <button onClick={onSubmit_func}>Save Changes <i className="fa fa-check"></i></button>
            </div>
        </section>
    )
}

const MapStateToProps = (state) => {
    return {
        email: state.auth_reducer.email,
        username: state.auth_reducer.username
    }
}

export default connect(MapStateToProps)(Editprofile_)